<template>
  <div>
    <div class="bg-white rounded-sm m-2">
      <b-row>
        <b-col cols="12" class="m-2">
          <b-row>
            <b-col cols="6">
              <span class="text-xs px-2 py-1 text-red">
                <b>0</b> Total Submissions
              </span>
              <span class="text-xs px-2 py-1 text-blue ml-2">
                <b>0</b> Assigned
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white rounded-sm m-2">
      <b-row v-if="getSearchReportTask.data != null">
        <b-col cols="12" class="mx-3 mt-3">
          <b-row>
            <b-col>
              <span class="bg-blue text-white px-2 py-1 rounded-sm text-xs font-bold">#SearchReport</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-row v-if="getSearchReportTask.data == null" class="py-5">
            <b-col cols="12" class="py-5">
              <b-row>
                <b-col cols="12" class="text-center justify-content-center">
                  <img :src="require('../../../../../assets/images/ic_empty_box.png')" class="icon mx-auto">
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12" class="text-center">
                  <div class="h5 text-gray mx-auto">There are no Search Report Applications left in the queue</div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="text-center">
                  <div class="text-gray mx-auto">Tasks will be available when clients submit new <b class="text-blue">applications</b> or when <b class="text-orange">queries</b> are responded to.</div>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12" class="text-center">
                  <button class="text-white bg-blue rounded-md px-2 py-2 mx-auto hover:bg-blue-dark" @click="checkForUpdates">Check for Updates</button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else>
            <SearchReportTask/>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SearchReportTask from "@/views/home/services/search_reports/task/SearchReportTask.vue";
export default {
  name: "SearchReportTaskQueue",
  components: { SearchReportTask},
  data(){
    return{
      margin:"2px",
      loading:true,
      task:{}
    }
  },
  mounted() {
    let id = JSON.parse(sessionStorage.getItem("current_user")).userId
    this.fetchSearchReportTask(id)
  },
  methods:{
    ...mapActions(["fetchSearchReportTask", "fetchCertificationTaskCount"]),
    checkForUpdates(){
      this.loading = true
      let id = JSON.parse(sessionStorage.getItem("current_user")).userId
      this.fetchSearchReportTask(id)
    },
  },
  computed:{
    ...mapGetters(["getSearchReportTask", "getSearchReportTaskError"])
  },
  watch:{
    getSearchReportTask(data){
      if(data.data === null){
        this.successToast("Message", data.message)
      }
    }
  }
};
</script>

<style scoped>
.icon{
  width: 170px;
}
</style>